[
  {
    "code": "SK-BC",
    "name": "Banskobystrický kraj"
  },
  {
    "code": "SK-BL",
    "name": "Bratislavský kraj"
  },
  {
    "code": "SK-KI",
    "name": "Košický kraj"
  },
  {
    "code": "SK-NI",
    "name": "Nitriansky kraj"
  },
  {
    "code": "SK-PV",
    "name": "Prešovský kraj"
  },
  {
    "code": "SK-TC",
    "name": "Trenciansky kraj"
  },
  {
    "code": "SK-TA",
    "name": "Trnavský kraj"
  },
  {
    "code": "SK-ZI",
    "name": "Žilinský kraj"
  }
]